import { render, staticRenderFns } from "./RegisterRules.vue?vue&type=template&id=49d832d8&scoped=true"
import script from "./RegisterRules.vue?vue&type=script&lang=js"
export * from "./RegisterRules.vue?vue&type=script&lang=js"
import style0 from "./RegisterRules.vue?vue&type=style&index=0&id=49d832d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d832d8",
  null
  
)

export default component.exports